
import Vue from "vue";
import MemberTag from "./MemberTag.vue";
import CardData from "../models/CardData";
import { ITag } from "../@types/interface.d";

type Prop<T> = () => T;

const MOVIES = [{
  title: "ライブ映像(3000days)",
  url: "https://youtu.be/Rr4ERd5ZtLg",
}, {
  title: "ライブ映像(Let's シンガソング)",
  url: "https://youtu.be/Rr4ERd5ZtLg?t=365s",
}, {
  title: "ライブ映像(桜プロミス)",
  url: "https://youtu.be/FRxmNolX4g0",
}, {
  title: "ライブ映像(sister)",
  url: "https://youtu.be/FRxmNolX4g0&t=255s",
}, {
  title: "ライブ映像(Trophy Girl)",
  url: "https://youtu.be/cGUV6q9NOok?t=78s",
}, {
  title: "ライブ映像(宇宙に行こう)",
  url: "https://youtu.be/cGUV6q9NOok&t=335s",
}, {
  title: "ライブ映像(re;star)",
  url: "https://youtu.be/ISOrw_vFB7Y",
}, {
  title: "ライブ映像(Chim Chim Chim Knee)",
  url: "https://youtu.be/ISOrw_vFB7Y&t=236s",
}, {
  title: "MV(re;star)",
  url: "https://youtu.be/JXNrEM0Nxa4",
}, {
  title: "MV(伊達サンバ)",
  url: "https://youtu.be/yjaI0ZV4_V0",
}, {
  title: "MV(BUBBLE POPPIN)",
  url: "https://youtu.be/z2-oBubDE9I",
}, {
  title: "MV(おぼろ花火)",
  url: "https://youtu.be/Na0Vy9vc9qk",
}, {
  title: "ライブ映像(恋はじめ)",
  url: "https://youtu.be/yEkCVVnGlLQ",
}, {
  title: "ライブ映像(Love is here)",
  url: "https://youtu.be/VoIbBq9caog",
}, {
  title: "ライブ映像(コンビニエント・エゴ)",
  url: "https://youtu.be/VoIbBq9caog?t=150s",
}, {
  title: "ライブ映像(いただきランチャー)",
  url: "https://youtu.be/PxGVcawGhxs",
}, {
  title: "ライブ映像(リライトガール)",
  url: "https://youtu.be/cfE6eh1zgQY",
}, {
  title: "MV(うぢらとおめだづ)",
  url: "https://youtu.be/yi7-QkvXdXU",
}, {
  title: "ライブ映像(天下一品)",
  url: "https://youtu.be/hCuJode1YHQ?t=152",
}, {
  title: "ライブ映像(TOHOKU FUNKY RAIL)",
  url: "https://youtu.be/hCuJode1YHQ?t=422",
}, {
  title: "ライブ映像(我ら)",
  url: "https://youtu.be/hnpTEnQ1Ejg",
}, {
  title: "Dance Practice(HANA)",
  url: "https://youtu.be/YUzGo9nvy1k",
}, {
  title: "ライブ映像(Whatever)",
  url: "https://youtu.be/hnpTEnQ1Ejg?t=157",
}, {
  title: "ライブ映像(おのぼりガール)",
  url: "https://youtu.be/S6d5Z6xpSws?t=52",
}];

export default Vue.extend({
  name: "LargeCard",
  components: {
    MemberTag,
  },
  props: {
    card: Object as Prop<CardData>,
  },
  computed: {
    movie() {
      const n = Math.floor(Math.random() * MOVIES.length);
      return MOVIES[n];
    },
  },
  methods: {
    loaded() {
      if (this.card.height > 0 && this.card.width > 0) {
        return;
      }
      const img = new Image();
      img.src = this.card.imageUrl;
      if (img.height === 0 || img.width === 0) {
        return;
      }
      fetch(`/api/single_card/${this.card.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "tohokusan",
        },
        body: JSON.stringify({
          height: img.height,
          width: img.width,
        }),
      }).then(() => {
        console.log("update image", img.height, img.width);
      });
    },
    click() {
      this.$emit("click", this.card);
    },
    twitterShare() {
      const tags = ["いぎなり東北産"].concat(this.card.tags.map((v: ITag) => v.name));
      const href = `${location.protocol}//${location.host}/cards/images/${this.card.id}`;
      const params = "text=いぎなり東北産を応援してます！&url=" + href + "&hashtags=" + tags.join(",");
      const url = `https://twitter.com/intent/tweet?${params}`;
      window.open(url);
    },
  },
});

